<template>
  <div class="ask_o">
    <div :class="{ pc: true, ask: true, active: askActive }">
      <div class="item phone" v-if="pz.r1">
        <div>
          <div class="right">
            <a :href="pz.r1.url" @click="phoneCallTrack">{{ pz.r1.content }}</a>
          </div>
          <div class="left">
            <p><img :src="pz.r1.logo" alt="" /></p>
            <p>{{ pz.r1.title }}</p>
          </div>
        </div>
      </div>
      <div class="item top left-slide">
        <a href="javascript:;" @click="openWi">
          <div class="left">
            <p><img src="@/assets/images/zxkf.svg" alt="" /></p>
            <p>在线客服</p>
          </div>
        </a>
      </div>
      <div class="item top left-slide" @click="toTop" v-if="showBackToTop">
        <div>
          <div class="left">
            <p><img src="@/assets/images/backup.svg" alt="" /></p>
            <p>返回顶部</p>
          </div>
        </div>
      </div>
    </div>
    <div class="m">
      <a href="javascript:;" @click="openWi"><img src="@/assets/images/zxkf.svg" alt="" />在线客服</a>
      <a :href="pz.r1.url" v-if="pz.r1" @click="phoneCallTrack"><img :src="pz.r1.logo" alt="" />电话咨询</a>
    </div>
  </div>
</template>
<script>
import { openYsf } from '@/lib/qiyuSDK'
const ToTopInterval = 10
const ScollValue = 80
export default {
  name: 'Ask',
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    scrollContent: [HTMLDivElement, Function],
    backToTop: {
      type: [Number, Function],
      default: 300,
    },
  },
  data() {
    return {
      showBackToTop: false,
      askActive: true,
      timer: null,
      pz: {},
      loginUrl: '',
      logined: false,
      scrollContentWrapper: null,
      destroyScroll: null,
    }
  },
  mounted() {
    this.getPz()
    this.scroll()
    this.destroyScroll = this.bindScroll(this.scroll)
  },
  beforeDestroy() {
    this.destroyScroll && this.destroyScroll()
  },
  methods: {
    qiyuTrack() {
      console.log('click_customer_service is tracked')
      this.$tsignData.track('click_customer_service')
    },
    phoneCallTrack() {
      console.log('click_phone_call is tracked!')
      this.$tsignData.track('click_phone_call')
    },
    async openWi() {
      this.qiyuTrack()
      openYsf(this.user, {
        robotShuntSwitch: 0, // 关闭机器人优先
        groupid: '397595188',
      })
    },
    bindScroll(callback) {
      let ticking = false
      const onScroll = () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            callback && callback()
            ticking = false
          })
          ticking = true
        }
      }
      onScroll()
      window.addEventListener('scroll', onScroll, true)

      return () => window.removeEventListener('scroll', onScroll)
    },
    getScrollWrapper() {
      if (this.scrollContentWrapper) return this.scrollContentWrapper
      this.scrollContentWrapper = typeof this.scrollContent === 'function' ? this.scrollContent() : this.scrollContent
      if (!this.scrollContentWrapper) {
        this.scrollContentWrapper = document.documentElement || document.body
        console.warn('ask.vue :: getScrollWrapper, wrapper is null!!！')
      }

      return this.scrollContentWrapper
    },
    scroll() {
      const topValue = typeof this.backToTop === 'function' ? this.backToTop() : this.backToTop
      this.showBackToTop = topValue < this.getScrollWrapper().scrollTop
    },
    toTop() {
      const scrollContentWrapper = this.getScrollWrapper()
      const { scrollTop } = scrollContentWrapper
      if (scrollTop > 0) {
        window.requestAnimationFrame(() => this.toTop())
        scrollContentWrapper.scrollTop = scrollTop - scrollTop / 5
      }
    },
    async getPz() {
      const r1 = (await this.$axios.get(`/api/config/show/10001`).catch(() => {})) || {}
      // var r8 = await this.$axios.$get(`/api/config/show/10008`)
      this.pz = {
        r1: r1.data,
        // r8:r8.data,
      }
    },
  },
}
</script>
<style lang="less" scoped>
.ask_o {
  .ask {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    height: 182px;
    text-align: center;
    z-index: 10000;
    transform: translateX(100%);
    transition: all 0.4s ease-in-out;

    &.active {
      transform: translateX(0%);
    }

    .item {
      margin-top: 1px;
      cursor: pointer;
      text-align: right;
      overflow: hidden;

      &:first-child {
        margin-top: 0;
      }

      & > a,
      & > div {
        display: block;
        height: 60px;

        .left {
          float: right;
          padding-top: 10px;
          padding-bottom: 4px;
          width: 60px;
          height: 60px;
          background-color: #e61717;
          color: #fff;
          border-radius: 4px 0px 0px 4px;
          overflow: hidden;
          text-align: center;
          img {
            width: 28px;
            display: block;
            margin: auto;
          }

          p {
            &:first-child {
              font-size: 22px;
            }

            &:last-child {
              font-size: 12px;
              line-height: 16px;
            }
          }
        }

        .right {
          float: right;
          text-align: center;
          height: 60px;
          line-height: 60px;
          width: 0px;
          background-color: #e61717;
          color: #fff;

          a {
            color: inherit;
            font-size: 20px;
          }
        }
      }
      &.phone {
        margin-right: -150px;
        transition: all 0.2s linear;
        background-color: #e61717;
        .right {
          width: 150px;
        }
      }
      &.phone:hover {
        transform: translateX(-150px);
      }
    }

    .left-slide {
      transition: all 0.2s linear;
      padding-right: 15px;
      margin-right: -15px;
      background-color: #e61717;
      &:hover {
        transform: translateX(-15px);
      }
    }
  }
  .m {
    display: none;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 99999;
    a {
      width: 50%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #fff;
      background: #000;
      &:nth-child(2) {
        background: #e61717;
      }
      img {
        width: 24px;
        margin-right: 10px;
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .ask_o {
    .pc {
      display: none;
    }
    .m {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>

<style>
#YSF-BTN-HOLDER {
  display: none !important;
}
#YSF-BTN-HOLDER {
  position: fixed;
  max-width: 70px;
  max-height: 70px;
  right: 35px;
  bottom: 270px;
  cursor: pointer;
  overflow: visible;
  filter: alpha(opacity=100);
  opacity: 1;
  z-index: 9990;
}
#YSF-CUSTOM-ENTRY-7 {
  position: relative;
  width: auto;
  background-color: #f05050;
  border-radius: 50%;
  box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.25);
}
</style>
